import Image from 'next/image';
import {
  getStaticAssetUrl,
  StaticAssetType,
} from '../../../common/shared/utils/getStaticAssetUrl';
import {preventDefaultEvent} from '../../../common/shared/utils/preventDefaultEvent.function';
import {useIsDarkMode} from '../../../common/useIsDarkMode.hook';
import {getInternalAssetImage} from './getInternalAssetImage.function';
import {STATIC_IMAGE_INFO_MAP} from './StaticImageInfoMap.constant';
import {
  NextImagePlaceHolder,
  StaticImageProps,
} from './StaticImageProps.interface';

/**
 * 디자인팀이 정해 준 고정 이미지들. Static 서버에 넣어두고 사용한다.
 * 정해진 이미지 중 골라 사용하므로 유동적인 src값 대신 정해진 image type으로 src를 결정함
 * Badge와 Icon 두 Atom은 구현체는 완전 동일하지만, 쓰이는 곳에 따라 디자인팀이 분류 해 뒀기 때문에
 * Badge와 Icon에서 가져다 쓸 static image atom을 구현함
 */
export function StaticImage({
  imageType,
  placeholder = 'empty',
  optimize = false,
  alt,
  ...props
}: StaticImageProps) {
  const imageInfo = STATIC_IMAGE_INFO_MAP[imageType];
  const isDarkMode = useIsDarkMode();
  return (
    <>
      {/* static은 light/dark 모두 동일한 아이콘을 사용해서 컬러모드 분기를 타지
      않습니다. */}
      {imageInfo.srcStatic && (
        <Image
          unoptimized={!optimize}
          alt={alt ?? imageInfo.alt}
          src={
            imageInfo.isInternal
              ? getInternalAssetImage(imageInfo.srcStatic)
              : getStaticAssetUrl(imageInfo.srcStatic, StaticAssetType.Image)
          }
          width={imageInfo.width}
          height={imageInfo.height}
          placeholder={placeholder as NextImagePlaceHolder}
          onSelect={preventDefaultEvent}
          onDragStart={preventDefaultEvent}
          onContextMenu={preventDefaultEvent}
          {...props}
        />
      )}
      {imageInfo.srcDark && isDarkMode && (
        <Image
          unoptimized={!optimize}
          alt={alt ?? imageInfo.alt}
          src={
            imageInfo.isInternal
              ? getInternalAssetImage(imageInfo.srcDark)
              : getStaticAssetUrl(imageInfo.srcDark, StaticAssetType.Image)
          }
          width={imageInfo.width}
          height={imageInfo.height}
          placeholder={placeholder as NextImagePlaceHolder}
          onSelect={preventDefaultEvent}
          onDragStart={preventDefaultEvent}
          onContextMenu={preventDefaultEvent}
          {...props}
        />
      )}
      {imageInfo.srcLight && !isDarkMode && (
        <Image
          unoptimized={!optimize}
          alt={alt ?? imageInfo.alt}
          src={
            imageInfo.isInternal
              ? getInternalAssetImage(imageInfo.srcLight)
              : getStaticAssetUrl(imageInfo.srcLight, StaticAssetType.Image)
          }
          width={imageInfo.width}
          height={imageInfo.height}
          placeholder={placeholder as NextImagePlaceHolder}
          onSelect={preventDefaultEvent}
          onDragStart={preventDefaultEvent}
          onContextMenu={preventDefaultEvent}
          {...props}
        />
      )}
    </>
  );
}
